import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/layout/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/accordion.tsx");
